import 'css-chunksrc/client/scenes/workloads/wbs/milestone/milestoneCompletion/styles.scss';export default {
  "icon": "_icon_19036_1",
  "completed": "_completed_19036_9",
  "input": "_input_19036_13",
  "listRoot": "_listRoot_19036_28",
  "list": "_list_19036_28",
  "item": "_item_19036_49",
  "name": "_name_19036_56",
  "doneName": "_doneName_19036_62",
  "open": "_open_19036_66",
  "done": "_done_19036_62",
  "readOnly": "_readOnly_19036_84"
};